import { cn } from '@costar-ui/cosmos';
import React__default from 'react';
import { Headline } from '../atoms/headline/headline.esm.js';

//TODO: FAISAL: CHANGED
//import { Divider } from '@costar-ui/components' //BREAKS BIMMO!
var SectionCardLayout = function SectionCardLayout(_ref) {
  var sectionHeading = _ref.sectionHeading,
    viewMore = _ref.viewMore,
    automationId = _ref.automationId,
    className = _ref.className,
    _ref$headlineTag = _ref.headlineTag,
    headlineTag = _ref$headlineTag === void 0 ? 'h2' : _ref$headlineTag;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn('mb-4 flex flex-col', className)
  }, /*#__PURE__*/React__default.createElement("div", {
    "automation-id": automationId,
    className: " mb-2 flex h-7 flex-row items-center justify-between "
  }, /*#__PURE__*/React__default.createElement(Headline, {
    as: headlineTag,
    className: "text-p-16/5 font-bold lg:text-p-24/7"
  }, sectionHeading), viewMore && /*#__PURE__*/React__default.createElement("div", {
    className: "text-p-14/[21px] font-normal hover:underline lg:text-p-16"
  }, viewMore)), /*#__PURE__*/React__default.createElement("hr", {
    className: "border-neutral/50"
  }));
};

export { SectionCardLayout };
//# sourceMappingURL=section-card-layout.esm.js.map
